import { jsx as _jsx } from "react/jsx-runtime";
import { Alert } from '@mui/material';
import { useMemo } from 'react';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const ObjectGraphCardWidget = () => {
    const component = useMemo(() => (_jsx(Alert, { severity: "error", children: "This widget does not load without causing errors: 'google.visualization.DataTable is not a constructor' \u2014 from convertHistoryObjectToDataTable()" })), []);
    return {
        name: 'ObjectGraphCard',
        category: 'generic',
        component,
    };
};
